/** Firestore 등록 전에도 메인에 노출할 대표 프로필 (slug 중복 시 Firestore 우선) */
export interface FeaturedTrainingProfile {
  publicSlug: string;
  displayName: string;
  schoolName?: string;
  bio?: string;
  photoURL?: string;
  /** legacy면 기존 MARU 연수 대시보드로 이동 */
  legacyPath?: string;
}

/** Firestore에 등록된 교사 프로필만 메인에 표시. 레거시 MARU 카드는 제거(허브로 이전). */
export const FEATURED_TRAINING_PROFILES: FeaturedTrainingProfile[] = [];
